/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ provider: NonNullable<unknown> }} Templates_Ai_AppliedInputs */

const cs_templates_ai_applied = /** @type {(inputs: Templates_Ai_AppliedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Layout aktualizován (${i?.provider})`)
};

const en_templates_ai_applied = /** @type {(inputs: Templates_Ai_AppliedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Layout updated (${i?.provider})`)
};

/**
* | output |
* | --- |
* | "Layout updated ({provider})" |
*
* @param {Templates_Ai_AppliedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_ai_applied = /** @type {((inputs: Templates_Ai_AppliedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Ai_AppliedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_ai_applied(inputs)
	return cs_templates_ai_applied(inputs)
});